import * as THREE from 'three'

import Experience from './Experience.js'
import { egg } from './zhuyuData.js'

/* 生日彩蛋：7.14 自动触发（含 3D 彩灯气球）/ 点礼物盒 / 页脚星星 / ?hbd */
export default class ZhuyuEgg
{
    constructor(_props)
    {
        this.experience = new Experience()
        this.time = this.experience.time
        this.props = _props

        this.overlay = document.getElementById('eggOverlay')
        this.canvas = document.getElementById('eggConfetti')
        this.confettiRAF = null

        document.getElementById('eggTitle').textContent = egg.title
        const msgBox = document.getElementById('eggMsg')
        egg.message.forEach((line) =>
        {
            const p = document.createElement('p')
            p.textContent = line
            msgBox.appendChild(p)
        })
        const photoBox = document.getElementById('eggPhotos')
        ;(egg.photos || []).forEach((src) =>
        {
            const img = document.createElement('img')
            img.src = src
            img.alt = '照片'
            img.loading = 'lazy'
            photoBox.appendChild(img)
        })

        document.getElementById('eggClose').addEventListener('click', () => this.close())
        document.getElementById('starEgg').addEventListener('click', () => this.open())

        const now = new Date()
        const isBirthday = now.getMonth() + 1 === egg.month && now.getDate() === egg.day
        const forced = /[?&]hbd\b/.test(location.search)

        if(isBirthday || forced)
        {
            this.setDecorations()
            let seen = null
            const key = 'hbd-seen-' + now.getFullYear()
            try { seen = localStorage.getItem(key) } catch(e) { /* 隐私模式 */ }
            if(!seen || forced)
            {
                try { localStorage.setItem(key, '1') } catch(e) { /* ignore */ }
                setTimeout(() => this.open(), 2600)
            }
        }

        try
        {
            console.log('%c煮鱼频道 · KEEP UP_', 'color:#ff6a00; font-size:16px; font-family:monospace;')
            console.log('%c你果然打开了控制台，不愧是玩 NAS 的。\n这间房是专门为你搭的，里面藏了个礼物盒，找到它。', 'color:#8a8a96; font-size:12px;')
        }
        catch(e) { /* ignore */ }
    }

    /* 气球着色贴图：把高光/明暗/环境紫调直接画进 equirect 贴图（场景无实时灯光） */
    balloonTexture(hex)
    {
        const cv = document.createElement('canvas')
        cv.width = 256
        cv.height = 256
        const c = cv.getContext('2d')
        const base = new THREE.Color(hex)
        const light = base.clone().lerp(new THREE.Color(0xffffff), 0.35)
        const dark = base.clone().multiplyScalar(0.32)
        const ambient = base.clone().lerp(new THREE.Color(0x8a6ab8), 0.4)

        /* 纵向明暗：顶部受环境紫光，中上最亮，向下渐暗 */
        const g = c.createLinearGradient(0, 0, 0, 256)
        g.addColorStop(0, '#' + ambient.getHexString())
        g.addColorStop(0.22, '#' + light.getHexString())
        g.addColorStop(0.55, '#' + base.getHexString())
        g.addColorStop(1, '#' + dark.getHexString())
        c.fillStyle = g
        c.fillRect(0, 0, 256, 256)

        /* 镜面高光（单一经度上，气球会旋转朝向相机侧） */
        const hl = c.createRadialGradient(88, 62, 4, 88, 62, 46)
        hl.addColorStop(0, 'rgba(255,255,255,.95)')
        hl.addColorStop(0.4, 'rgba(255,255,255,.28)')
        hl.addColorStop(1, 'rgba(255,255,255,0)')
        c.fillStyle = hl
        c.beginPath()
        c.ellipse(88, 62, 30, 44, -0.35, 0, 7)
        c.fill()

        const t = new THREE.CanvasTexture(cv)
        t.encoding = THREE.sRGBEncoding
        return t
    }

    /* 3D 装饰：气球 + 两面墙的彩灯串（仅生日/hbd 模式） */
    setDecorations()
    {
        const g = new THREE.Group()

        /* 夜晚房间配色：暖橙金红为主，微降饱和 */
        const balloonColors = [0xf06a1e, 0xd9a12e, 0xc23b32, 0x3fb8ae, 0x8a63c9]
        const spots = [
            [-3.9, 5.6, 2.2], [-1.5, 6.2, -2.5], [3.9, 6.0, -2.8], [3.6, 5.9, 1.6], [0.4, 6.3, 2.8]
        ]
        this.balloons = []
        spots.forEach(([x, y, z], i) =>
        {
            const b = new THREE.Group()
            const body = new THREE.Mesh(
                new THREE.SphereGeometry(0.32, 24, 18),
                new THREE.MeshBasicMaterial({ map: this.balloonTexture(balloonColors[i]) })
            )
            body.scale.set(1, 1.22, 1)
            /* 高光经度转向相机方向（相机在 +x+z 象限） */
            body.rotation.y = Math.PI * 0.75 + (i - 2) * 0.15

            const knotColor = new THREE.Color(balloonColors[i]).multiplyScalar(0.45)
            const knot = new THREE.Mesh(
                new THREE.ConeGeometry(0.05, 0.08, 10),
                new THREE.MeshBasicMaterial({ color: knotColor })
            )
            knot.position.y = -0.44
            knot.rotation.x = Math.PI

            /* 弯曲垂线（微弯避免死直） */
            const pts = []
            for(let s = 0; s <= 8; s++)
            {
                const tt = s / 8
                pts.push(new THREE.Vector3(Math.sin(tt * 2.6 + i) * 0.05, -0.48 - tt * 1.5, Math.cos(tt * 2.2 + i) * 0.04))
            }
            const string = new THREE.Mesh(
                new THREE.TubeGeometry(new THREE.CatmullRomCurve3(pts), 12, 0.0035, 4),
                new THREE.MeshBasicMaterial({ color: 0x4a4650, transparent: true, opacity: 0.7 })
            )

            b.add(body, knot, string)
            b.position.set(x, y, z)
            g.add(b)
            this.balloons.push({ mesh: b, baseY: y, phase: i * 1.3 })
        })

        /* 彩灯串：沿两面墙顶各拉一条 */
        this.bulbs = []
        const runs = [
            { from: [-4.65, 5.9, 4.4], to: [-4.65, 5.9, -4.6] },
            { from: [-4.6, 5.9, -4.65], to: [4.6, 5.9, -4.65] }
        ]
        const bulbColors = [0xff6a00, 0xe8b31a, 0x4ecdc4, 0xd0342c]
        runs.forEach((run) =>
        {
            for(let i = 0; i <= 14; i++)
            {
                const t = i / 14
                const sag = Math.sin(t * Math.PI * 3) * 0.001 + Math.abs(Math.sin(t * Math.PI * 3.5)) * -0.18
                const bulb = new THREE.Mesh(
                    new THREE.SphereGeometry(0.05, 8, 6),
                    new THREE.MeshBasicMaterial({ color: bulbColors[i % 4] })
                )
                bulb.position.set(
                    run.from[0] + (run.to[0] - run.from[0]) * t,
                    run.from[1] + sag,
                    run.from[2] + (run.to[2] - run.from[2]) * t
                )
                g.add(bulb)
                this.bulbs.push({ mesh: bulb, index: i })
            }
        })

        this.decor = g
        this.experience.scene.add(g)
    }

    update()
    {
        const t = this.time.elapsed
        if(this.balloons)
        {
            this.balloons.forEach((b) =>
            {
                b.mesh.position.y = b.baseY + Math.sin(t * 0.0008 + b.phase) * 0.15
                b.mesh.rotation.z = Math.sin(t * 0.0006 + b.phase) * 0.06
            })
        }
        if(this.bulbs)
        {
            this.bulbs.forEach((b) =>
            {
                const on = Math.sin(t * 0.005 + b.index * 0.9) > -0.2
                b.mesh.material.opacity = 1
                b.mesh.scale.setScalar(on ? 1 : 0.55)
            })
        }
    }

    /* ---------- overlay ---------- */
    open()
    {
        if(!this.overlay.hidden)
            return
        this.overlay.hidden = false
        this.startConfetti()
    }

    close()
    {
        this.overlay.hidden = true
        this.stopConfetti()
    }

    startConfetti()
    {
        const ctx = this.canvas.getContext('2d')
        let W, H
        const resize = () => { W = this.canvas.width = innerWidth; H = this.canvas.height = innerHeight }
        resize()
        window.addEventListener('resize', resize)
        const colors = ['#ff6a00', '#ffd166', '#d0342c', '#4ecdc4', '#ededf2']
        const parts = []
        for(let i = 0; i < 140; i++)
        {
            parts.push({
                x: Math.random() * W, y: -20 - Math.random() * H,
                w: 6 + Math.random() * 6, h: 4 + Math.random() * 4,
                vy: 1.6 + Math.random() * 2.6, vx: -1 + Math.random() * 2,
                rot: Math.random() * Math.PI, vr: -0.1 + Math.random() * 0.2,
                c: colors[i % colors.length]
            })
        }
        const loop = () =>
        {
            ctx.clearRect(0, 0, W, H)
            parts.forEach((p) =>
            {
                p.y += p.vy
                p.x += p.vx + Math.sin(p.y / 40)
                p.rot += p.vr
                if(p.y > H + 20) { p.y = -20; p.x = Math.random() * W }
                ctx.save()
                ctx.translate(p.x, p.y)
                ctx.rotate(p.rot)
                ctx.fillStyle = p.c
                ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h)
                ctx.restore()
            })
            this.confettiRAF = requestAnimationFrame(loop)
        }
        loop()
    }

    stopConfetti()
    {
        if(this.confettiRAF)
            cancelAnimationFrame(this.confettiRAF)
        this.confettiRAF = null
        const ctx = this.canvas.getContext('2d')
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
    }
}
